// extracted by mini-css-extract-plugin
export default {"content":"CasinoFavorites_content__JyndU","games":"CasinoFavorites_games__-AKHb"};